import { AngularFireModule } from 'angularfire2';
import { environment } from '../environments/environment';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AuthService } from '../app/auth-service/auth.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SociogramComponent } from './sociogram/sociogram.component';
import { HomeComponent } from './home/home.component';
import { ReadClassComponent } from './read-class/read-class.component';
import { VisModule } from 'ngx-vis';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { AgGridModule } from 'ag-grid-angular';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { GraphComponent } from './graph/graph.component';
import { NgApexchartsModule } from 'ng-apexcharts';

@NgModule({
  declarations: [
    AppComponent,
    SociogramComponent,
    HomeComponent,
    ReadClassComponent,
    GraphComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    VisModule,
    MatSlideToggleModule,
    AgGridModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    NgApexchartsModule,
    MatListModule
  ],
  providers: [AuthService],
  bootstrap: [AppComponent]
})
export class AppModule { }
